exports = module.exports = require("../../node_modules/css-loader/lib/css-base.js")(undefined);
// imports


// module
exports.push([module.id, "#hotreview{width:100%;padding-bottom:30px;background-color:#f5f5f5}#hotreview .header{padding:15px 0;font:500 22px/40px Microsoft Yahei}#hotreview .content{width:283px;height:400px;float:left;margin-right:20px;background-color:#fff}#hotreview .content:last-of-type{margin-right:0}#hotreview .content:hover{box-shadow:0 15px 30px rgba(0,0,0,.1);transform:translate3d(0,-2px,0)}#hotreview .content img{width:100%;height:220px}#hotreview .content p{margin:0;font-size:14px;padding:5px 23px;color:#666}#hotreview .content p:first-of-type{margin-top:20px;height:72px;display:block}#hotreview .content p:nth-of-type(2){color:#aaa}#hotreview .content p span{color:#ff6700}", ""]);

// exports



//////////////////
// WEBPACK FOOTER
// ./node_modules/css-loader!./node_modules/vue-loader/lib/style-compiler?{"vue":true,"id":"data-v-2dd7a9ad","scoped":false,"hasInlineConfig":false}!./node_modules/sass-loader/lib/loader.js!./node_modules/vue-loader/lib/selector.js?type=styles&index=0!./src/components/hotreview.vue
// module id = 56
// module chunks = 0